import React from 'react'
import LinkItem from './Link'
import * as UIcons from '@iconscout/react-unicons'

export default function BreadCrumb({ items }) {
  return (
    <ul className={`w-full text-primary font-medium mb-5`}>
      {
        items.map((item, index) => {
          return (
            <React.Fragment key={ item.name }>
              {
                (index === items.length - 1) ? (
                  <li className="inline-block">
                    {
                      item.name
                    }
                  </li>
                ) : item.onClick ? (
                  <li className="inline-block">
                    <button type="button" onClick={item.onClick} className="text-primary py-1 flex items-center">
                      { item.name } <UIcons.UilAngleRight className="text-placeholder" />
                    </button>
                  </li>
                ) : (

                  <li className="inline-block">
                    <LinkItem
                      classList="text-primary py-1 flex items-center"
                      url={ item.url }
                      tag={
                        () => <>
                          { item.name } <UIcons.UilAngleRight className="text-placeholder" />
                        </>
                      }
                    />
                  </li>
                )
              }
            </React.Fragment>
          ) 
        })
      }
    </ul>
  )
}
